export default "__VITE_ASSET__Cp474iGK__"